import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router"
import { z } from "zod"

import { consentOverviewQueryOptions } from "@/features/patients/queries"
import { CONSENT_STATUS_VALUES } from "@/features/patients/constants"

const consentSearchSchema = z.object({
  search: z.string().optional().catch(""),
  page: z.coerce.number().catch(1),
  pageSize: z.coerce.number().catch(10),
  facility: z.coerce.number().optional().catch(undefined),
  primaryClinician: z.coerce.number().optional().catch(undefined),
  isActive: z.coerce.boolean().optional().catch(undefined),
  ordering: z.string().default("-user__created_at"),
  consentStatus: z.enum(CONSENT_STATUS_VALUES).optional().catch(undefined),
})

export const Route = createFileRoute("/_app/reports/consent/")({
  validateSearch: (search: SearchSchemaInput) =>
    consentSearchSchema.parse(search),

  loaderDeps: ({ search }) => search,

  loader: ({ context, deps }) => {
    return context.queryClient.ensureQueryData(
      consentOverviewQueryOptions({ params: { query: deps } })
    )
  },
})
